import { useAuth } from 'react-oidc-context'
import { useEffect, useRef } from 'react'

export function useLogAuthContext() {
  const auth = useAuth()
  useEffect(() => {
    if (auth.error) {
      console.error(`[AuthDebug] Auth error: ${auth.error.message}`)
    }
  }, [auth.error])

  const prev = useRef<unknown>({})

  useEffect(() => {
    const idTokenClaims = auth.user?.profile
    const idTokenExp = typeof idTokenClaims?.exp === 'number' ? idTokenClaims.exp : null
    const accessTokenExp = auth.user?.expires_at ?? null
    const now = Math.floor(Date.now() / 1000)
    const snapshot = {
      isLoading: auth.isLoading,
      tokenTail: auth.user?.access_token ? auth.user.access_token.slice(-12) : null,
      exp: accessTokenExp,
      now,
      secondsLeft: accessTokenExp ? accessTokenExp - now : null,
      error: auth.error?.message ?? null,
      idTokenExp,
      idTokenSecondsLeft: idTokenExp ? idTokenExp - now : null,
    }

    const snapshotStr = JSON.stringify(snapshot)
    const changed = snapshotStr !== JSON.stringify(prev.current)
    if (changed) {
      console.debug(`[AuthDebug] ${snapshotStr}`)
      prev.current = snapshot
    }
  }, [auth.user, auth.isLoading, auth.error])
}
